import CPCSIndustrialForklift from "../pages/cpcs/cpcsindustrialforklift";
import CPCSAgriculturalTractor from "../pages/cpcs/cpcsagriculturaltractor";
import CPCSForwardTippingDumper from "../pages/cpcs/cpcsforwarddumper";
import CPCSCrawlerCrane from "../pages/cpcs/cpcscrawlercrane";
import CPCSLiftingOperations from "../pages/cpcs/cpcsliftingoperations";
import CPCSPlantDriving from "../pages/cpcs/cpcsplantdriving";
import CPCSTowerCrane from "../pages/cpcs/cpcstowercrane";
import CPCSPlantMarshaller from "../pages/cpcs/cpcsplantmarshaller";
import CPCSExcavator180Below5T from "../pages/cpcs/cpcsexcavator180below5t";
import CPCSExcavator180Above5T from "../pages/cpcs/cpcsexacvator180above5t";
import CPCSRoughTerrainForklift from "../pages/cpcs/cpcsroughterrainforklift";
import CPCSSideLoader from "../pages/cpcs/cpcssideloader";
import CPCSReachTruckForklift from "../pages/cpcs/cpcsreachtruck";
import CPCSGrader from "../pages/cpcs/cpcsgrader";
import CPCSHoist from "../pages/cpcs/cpcshoist";
import CPCSWheeledShovelCourse from "../pages/cpcs/cpcswheeledshovel";
import CPCSTrackedLoadingShovel from "../pages/cpcs/cpcstrackingloadingshovel";
import CPCSSkidSteerLoader from "../pages/cpcs/cpcsskidsteer";
import CPCSMotorisedScraper from "../pages/cpcs/cpcsmotorisedscraper";
import CPCSMewpScissor from "../pages/cpcs/cpcsmewpscissor";
import CPCSMewpMastClimber from "../pages/cpcs/cpcsmewpmastclimber";
import CPCSPilingRigTripod from "../pages/cpcs/cpcspilingrigtripod";
import CPCSCrawlerTractorDozer from "../pages/cpcs/cpcscrawlertractordozer";
import CPCSCrawlerSideBoom from "../pages/cpcs/cpcscrawlertractorsideboom";
import CPCSTrencher from "../pages/cpcs/cpcstrencher";
import CPCSSkipHandler from "../pages/cpcs/cpcsskiphandler";
import CPCSSlingerSignaller from "../pages/cpcs/cpcsslingersignaller";
import CPCSLoaderCompressor from "../pages/cpcs/cpcsloadercompressor";
import CPCSCrusher from "../pages/cpcs/cpcscrusher";
import CPCSScreener from "../pages/cpcs/cpcsscreener";
import CPCSTrailerMountedConcretePump from "../pages/cpcs/cpcstrailermountedpump";
import CPCSPilingRigDrivenBelow20Tonnes from "../pages/cpcs/cpcspilingribelow20t";
import CPCSPilingRigDrivenAbove20Tonnes from "../pages/cpcs/cpcspilingrigabove20t";
import CPCSPilingRigBoredBelow20Tonnes from "../pages/cpcs/cpcspilingrigboredbelow20t";
import CPCSLoaderSecurer from "../pages/cpcs/cpcsloadersecurer";
import CPCSTelescopicHandler from "../pages/cpcs/cpcstelescopichandler";
import CPCSRideOnRoller from "../pages/cpcs/cpcsrideonroller";
import CPCSMEWPBoom from "../pages/cpcs/cpcsmewpboom";
import CPCSDragline from "../pages/cpcs/cpcsdragline";
import CPCSDumpTruckArticulated from "../pages/cpcs/cpcsdumptruckarticulated";
import CPCSDumpTruckRigid from "../pages/cpcs/cpcsdumptruckrigid";
import CPCSExcavator360Below10T from "../pages/cpcs/cpcsexcavator360below10t";
import CPCSExcavator360Above10T from "../pages/cpcs/cpcsexcavator360above10t";
import CPCSMobileCrane from "../pages/cpcs/cpcsmobilecrane";
import CPCSCompactCrane from "../pages/cpcs/cpcscompactcrane";
import CPCSPilingRigAttendant from "../pages/cpcs/cpcspilingrigattendant";
import CPCSConcretePlacingBoom from "../pages/cpcs/cpcsconcreteplacingboom";
import CPCSDemolitionPlant from "../pages/cpcs/cpcsdemolitionplant";
import CPCSSkidSteerToolCarrier from "../pages/cpcs/cpcsskidsteertoolcarrier";
import CPCSPilingRigBoredAbove20Tonnes from "../pages/cpcs/cpcspilingrigboredabove20t";
import CPCSSoilLandfillCompactor from "../pages/cpcs/cpcssoillandfillcompactor";
import CPCSCraneSupervisor from "../pages/cpcs/cpcscranesupervisor";
import CPCSOverheadCrane from "../pages/cpcs/cpcsoverheadcrane";
import CPCSTunnellingLocomotives from "../pages/cpcs/cpcstunnellinglocomotives";
import CPCSSoilStabiliser from "../pages/cpcs/cpcssoilstabiliser";
import CPCSConveyorPump from "../pages/cpcs/cpcsconveyorpump";
import CPCSTelescopicHandler360Slew from "../pages/cpcs/cpcstelescopichandler360slew";
import CPCSVacuumExcavator from "../pages/cpcs/cpcsvacuumexcavator";
import CPCSDemolitionPlantPedestrianOperated from "../pages/cpcs/cpcsdemolitionplantpedestrian";

const cpcsRoutes = [
  { path: "/cpcs-crawlercrane", element: <CPCSCrawlerCrane /> },
  { path: "/cpcs-industrialforklift", element: <CPCSIndustrialForklift /> },
  { path: "/cpcs-agriculturaltractor", element: <CPCSAgriculturalTractor /> },
  { path: "/cpcs-forwardtippingdumper", element: <CPCSForwardTippingDumper /> },
  { path: "/cpcs-liftingoperations", element: <CPCSLiftingOperations /> },
  { path: "/cpcs-plantdriving", element: <CPCSPlantDriving /> },
  { path: "/cpcs-towercrane", element: <CPCSTowerCrane /> },
  { path: "/cpcs-plantmarshaller", element: <CPCSPlantMarshaller /> },
  { path: "/cpcs-excavatorbelow5t", element: <CPCSExcavator180Below5T /> },
  { path: "/cpcs-excavatorabove5t", element: <CPCSExcavator180Above5T /> },
  { path: "/cpcs-roughterrainforklift", element: <CPCSRoughTerrainForklift /> },
  { path: "/cpcs-sideloader", element: <CPCSSideLoader /> },
  { path: "/cpcs-reachtruck", element: <CPCSReachTruckForklift /> },
  { path: "/cpcs-hoist", element: <CPCSHoist /> },
  { path: "/cpcs-grader", element: <CPCSGrader /> },
  { path: "/cpcs-wheeledshovel", element: <CPCSWheeledShovelCourse /> },
  { path: "/cpcs-trackedloadingshovel", element: <CPCSTrackedLoadingShovel /> },
  { path: "/cpcs-skidsteerloader", element: <CPCSSkidSteerLoader /> },
  { path: "/cpcs-motorisedscraper", element: <CPCSMotorisedScraper /> },
  { path: "/cpcs-mewpscissor", element: <CPCSMewpScissor /> },
  { path: "/cpcs-mewpmastclimber", element: <CPCSMewpMastClimber /> },
  { path: "/cpcs-pilingrigtripod", element: <CPCSPilingRigTripod /> },
  { path: "/cpcs-crawlertractordozer", element: <CPCSCrawlerTractorDozer /> },
  { path: "/cpcs-crawlertractorsideboom", element: <CPCSCrawlerSideBoom /> },
  { path: "/cpcs-trencher", element: <CPCSTrencher /> },
  { path: "/cpcs-skiphandler", element: <CPCSSkipHandler /> },
  { path: "/cpcs-slingersignaller", element: <CPCSSlingerSignaller /> },
  { path: "/cpcs-loadersignaller", element: <CPCSLoaderCompressor /> },
  { path: "/cpcs-crusher", element: <CPCSCrusher /> },
  { path: "/cpcs-screener", element: <CPCSScreener /> },
  {
    path: "/cpcs-trailermountedpump",
    element: <CPCSTrailerMountedConcretePump />,
  },
  {
    path: "/cpcs-pilingrigdrivenbelow20t",
    element: <CPCSPilingRigDrivenBelow20Tonnes />,
  },
  {
    path: "/cpcs-pilingrigdrivenabove20t",
    element: <CPCSPilingRigDrivenAbove20Tonnes />,
  },
  {
    path: "/cpcs-pilingrigboredbelow20t",
    element: <CPCSPilingRigBoredBelow20Tonnes />,
  },
  { path: "/cpcs-loadersecurer", element: <CPCSLoaderSecurer /> },
  { path: "/cpcs-telescopichandler", element: <CPCSTelescopicHandler /> },
  { path: "/cpcs-rideonroller", element: <CPCSRideOnRoller /> },
  { path: "/cpcs-mewpboom", element: <CPCSMEWPBoom /> },
  { path: "/cpcs-dragline", element: <CPCSDragline /> },
  { path: "/cpcs-dumptruckarticulated", element: <CPCSDumpTruckArticulated /> },
  { path: "/cpcs-dumptruckrigid", element: <CPCSDumpTruckRigid /> },
  { path: "/cpcs-excavator360below10t", element: <CPCSExcavator360Below10T /> },
  { path: "/cpcs-excavator360above10t", element: <CPCSExcavator360Above10T /> },
  { path: "/cpcs-mobilecrane", element: <CPCSMobileCrane /> },
  { path: "/cpcs-compactcrane", element: <CPCSCompactCrane /> },
  { path: "/cpcs-pilingrigattendant", element: <CPCSPilingRigAttendant /> },
  { path: "/cpcs-concreteplacingboom", element: <CPCSConcretePlacingBoom /> },
  { path: "/cpcs-demolitionplant", element: <CPCSDemolitionPlant /> },
  { path: "/cpcs-skidsteertoolcarrier", element: <CPCSSkidSteerToolCarrier /> },
  {
    path: "/cpcs-pilingrigboredabove20t",
    element: <CPCSPilingRigBoredAbove20Tonnes />,
  },
  {
    path: "/cpcs-soillandfillcompactor",
    element: <CPCSSoilLandfillCompactor />,
  },
  { path: "/cpcs-cranesupervisor", element: <CPCSCraneSupervisor /> },
  { path: "/cpcs-overheadcrane", element: <CPCSOverheadCrane /> },
  {
    path: "/cpcs-tunellinglocomotives",
    element: <CPCSTunnellingLocomotives />,
  },
  { path: "/cpcs-soilstabiliser", element: <CPCSSoilStabiliser /> },
  { path: "/cpcs-conveyorpump", element: <CPCSConveyorPump /> },
  {
    path: "/cpcs-telescopichandler360slew",
    element: <CPCSTelescopicHandler360Slew />,
  },
  { path: "/cpcs-vacuumexcavator", element: <CPCSVacuumExcavator /> },
  {
    path: "/cpcs-demolitionplantpedestrianoperated",
    element: <CPCSDemolitionPlantPedestrianOperated />,
  },
];

export default cpcsRoutes;
